document.addEventListener('DOMContentLoaded', () => {
  const VERCEL_URL = "https://sbarcade.vercel.app/api/shootinggame"; 
  
  const config = window.invaderConfig;
  const customerId = config.customerId || null;
  const customerEmail = config.customerEmail || "";
  const customerName = config.customerName || "Guest";
  let customerPhone = config.customerPhone || "";

  const canvas = document.getElementById('gameCanvas');
  const ctx = canvas.getContext('2d');
  const container = document.getElementById('gameContainer');

  canvas.width = 800; 
  canvas.height = 1000;

  let score = 0;
  let timeLeft = 60;
  let gameActive = false;
  let enemies = [];
  let bullets = [];
  let lives = 3;
  let lastFireTime = 0;
  const FIRE_RATE = 150; 

  const images = {
    player: new Image(),
    target: new Image(),
    trap: new Image(),
    fire: new Image()
  };

  images.player.src = 'https://cdn.shopify.com/s/files/1/0684/4923/9327/files/SB_Arcade_Elements-01.png?v=1776605239';
  images.target.src = 'https://cdn.shopify.com/s/files/1/0684/4923/9327/files/SB_Arcade_Elements-03.png?v=1776605239';
  images.trap.src = 'https://cdn.shopify.com/s/files/1/0684/4923/9327/files/SB_Arcade_Elements-04.png?v=1776605239';
  images.fire.src = 'https://cdn.shopify.com/s/files/1/0684/4923/9327/files/SB_Arcade_Elements-02.png?v=1776605239';

  const player = { x: 350, y: 850, w: 110, h: 110 };

  async function syncPlayerData() {
    if (!customerId) return;
    try {
      const res = await fetch(`${VERCEL_URL}?id=${customerId}`);
      const data = await res.json();
      lives = data.attempts_left ?? 3;
      document.getElementById('lives-count').innerText = lives;
      document.getElementById('high-score-display').innerText = data.high_score || 0;
      
      const lb = document.getElementById('launch-btn');
      if (lb && lives <= 0) {
        lb.disabled = true;
        lb.innerText = "NO LIVES LEFT";
        lb.style.opacity = "0.5";
      }
    } catch (e) { console.error("Sync Error:", e); }
  }

  async function saveResult(isFinal = true) {
    if (!customerId) return;
    try {
      await fetch(VERCEL_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: customerId, score, phone: customerPhone,
          name: customerName, email: customerEmail,
          subtractAttempt: isFinal 
        })
      });
      await syncPlayerData();
    } catch (e) { console.error("Save Error:", e); }
  }

  function startGame() {
    if (lives <= 0) return alert("No missions left today!");
    document.getElementById('start-screen').classList.add('hidden');
    gameActive = true; 
    score = 0; 
    bullets = []; 
    enemies = []; 
    timeLeft = 55; 
    document.getElementById('coin-count').innerText = "0";
    animate(); 
    startTimer();
  }

  function startTimer() {
    const t = setInterval(() => {
      if (timeLeft > 0 && gameActive) {
        timeLeft--; 
        document.getElementById('timer').innerText = timeLeft;
      } else {
        gameActive = false; 
        clearInterval(t);
        document.getElementById('game-over').classList.remove('hidden');
        document.getElementById('final-score').innerText = score;
        document.getElementById('best-score-over').innerText = document.getElementById('high-score-display').innerText;
        saveResult(true);
      }
    }, 1000);
  }

  function handleMove(e) {
    if (!gameActive) return;
    const rect = canvas.getBoundingClientRect();
    const clientX = (e.touches && e.touches[0]) ? e.touches[0].clientX : e.clientX;
    const scaleX = canvas.width / rect.width;
    player.x = (clientX - rect.left) * scaleX - player.w / 2;
    if (player.x < 0) player.x = 0;
    if (player.x > canvas.width - player.w) player.x = canvas.width - player.w;
  }

  function handleShoot() {
    const now = Date.now();
    if (!gameActive || (now - lastFireTime < FIRE_RATE)) return;
    bullets.push({ x: player.x + player.w/2 - 15, y: player.y - 40, w: 30, h: 60 });
    lastFireTime = now;
  }

  function animate() {
    if (!gameActive) return;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(images.player, player.x, player.y, player.w, player.h);

    for (let i = bullets.length - 1; i >= 0; i--) {
      bullets[i].y -= 25;
      ctx.drawImage(images.fire, bullets[i].x, bullets[i].y, bullets[i].w, bullets[i].h);
      if (bullets[i].y < -100) bullets.splice(i, 1);
    }

    for (let ei = enemies.length - 1; ei >= 0; ei--) {
      let en = enemies[ei]; 
      en.y += en.speed;
      ctx.drawImage(en.type === 'target' ? images.target : images.trap, en.x, en.y, en.w, en.h);

      for (let bi = bullets.length - 1; bi >= 0; bi--) {
        let b = bullets[bi];
        if (b.x < en.x + en.w && b.x + b.w > en.x && b.y < en.y + en.h && b.y + b.h > en.y) {
          if (en.type === 'target') {
            score += 5;
            container.classList.add('shake'); 
            setTimeout(() => container.classList.remove('shake'), 100);
          } else {
            score = Math.max(0, score - 2);
          }
          document.getElementById('coin-count').innerText = score;
          enemies.splice(ei, 1); 
          bullets.splice(bi, 1); 
          break;
        }
      }
      if (en && en.y > canvas.height) enemies.splice(ei, 1);
    }
    requestAnimationFrame(animate);
  }

  // Enemy Spawner
  setInterval(() => {
    if (!gameActive) return;
    enemies.push({ 
      x: Math.random() * (canvas.width - 80), 
      y: -80, w: 80, h: 80, 
      speed: 6 + (score/100), 
      type: Math.random() < 0.2 ? 'trap' : 'target' 
    });
  }, 600);

  // Bindings
  document.getElementById('launch-btn')?.addEventListener('click', startGame);
  document.getElementById('replay-btn')?.addEventListener('click', () => location.reload());
  
  const phoneBtn = document.getElementById('save-phone-btn');
  if (phoneBtn) {
    phoneBtn.onclick = async () => {
      const val = document.getElementById('egypt-phone').value;
      if (!/^01[0125][0-9]{8}$/.test(val)) return alert("INVALID PHONE");
      phoneBtn.innerText = "SAVING...";
      customerPhone = val;
      await saveResult(false);
      document.getElementById('phone-screen').style.display = 'none';
      document.getElementById('start-screen').style.display = 'flex';
      document.getElementById('stats-bar').style.display = 'flex';
    };
  }

  canvas.addEventListener('mousemove', handleMove);
  canvas.addEventListener('mousedown', handleShoot);
  canvas.addEventListener('touchstart', (e) => { handleMove(e); handleShoot(); e.preventDefault(); }, {passive: false});
  canvas.addEventListener('touchmove', (e) => { handleMove(e); handleShoot(); e.preventDefault(); }, {passive: false});

  if (customerId) syncPlayerData();
});